exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intBro[data-v-3642ad6c]{height:50px!important}", ""]);

// exports
